/**
 * Reads the double-submit CSRF cookie's value out of a `document.cookie`
 * string. Pure and framework-free so it can be tested without a DOM
 * (this project's Vitest config runs with `environment: "node"`).
 *
 * The cookie is deliberately NOT HttpOnly on the API side (see
 * services/api/internal/httpx/middleware.go's CSRFCookieName) — that is the
 * whole point of the double-submit pattern: JavaScript must be able to read
 * it and echo it back as a header on a state-changing request.
 */
export const CSRF_COOKIE_NAME = "uvi_csrf";

export function readCsrfCookie(cookieString: string): string {
  for (const part of cookieString.split(";")) {
    const trimmed = part.trim();
    if (!trimmed.startsWith(`${CSRF_COOKIE_NAME}=`)) continue;
    const value = trimmed.slice(CSRF_COOKIE_NAME.length + 1);
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }
  return "";
}
